import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getProductsTypes } from '../../../../store/selectors';
import '../../../../assets/stylesheets/ClubSlide/GameTransferRow.scss';
import { getProductType } from '../../../../store/sagas/helpers/transfers';

const GameTransferRow = ({ transfer }) => {
  const { t } = useTranslation();
  const productTypes = useSelector(getProductsTypes);
  const { productId, amount, date, balance, type, details } = transfer;
  const gameType = getProductType(productTypes, productId);

  return (
    <div className='gameTransferRow'>
      <div className={`gameTypeImage ${gameType ? gameType : 'defaultType'}`}></div>
      <div className="gameDetailsContainer">
        <div className='gameDetails'>
          <span className='gameType'>{t(gameType) || t('game')}</span>
          <div className='trasnferDate'>
            <p>{moment(date).format('DD.MM.YY')} <span className={`oval`}></span> {moment(date).format('HH:mm')}</p>
          </div>
        </div>
          <span className='game'>{details}</span>
        <div className={`trasnferType`}>
          <div className='clubBalance'>
          <span>{t(type)}</span>
            <div className='transferAmount'>
              <span className='balanceNumber' >{`${type === "buyin" ? '-' : '+'} ${amount}`}</span>
              <span className='chipIcon'></span>
            </div>
          </div>
          <div className={`transferBalance`}>
            <span>{t('balance')}</span>
            <div className={`clubBalance`}>
              <div className={`transferAmount`}>
                <span className={`balanceNumber`} >{balance}</span>
                <span className={`chipIcon`}></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GameTransferRow;
